import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { Observable } from "rxjs";
import { CompetitorsFilters } from "../../../../models/competitors-filter.model";
import { CompetitorListQueryParams } from "../../../../models/competitors-query.model";
import { CompetitorListData } from "../../models/competitor-list-data.model";
import { getFormModel } from "./competitor-list-filter-dialog-form-data";

@Component({
    selector: "ifb-competitor-list-filter-dialog",
    templateUrl: "./competitor-list-filter-dialog.component.html",
    standalone: false
})
export class CompetitorListFilterDialogComponent {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<CompetitorListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group(getFormModel(data.query));
  }

  static show(
    dialog: MatDialog,
    query: CompetitorListQueryParams,
    routeData: CompetitorListData
  ): Observable<any> {
    return dialog
      .open(CompetitorListFilterDialogComponent, {
        data: {
          query,
          routeData,
        },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new CompetitorsFilters(formValues));
  }
}
